export default function formatFileCategory(file_category: string) {
  switch (file_category) {
    case 'apostila':
      return 'Apostila';
    case 'exercicios':
      return 'Exercícios';
    case 'mapa_mental':
      return 'Mapa mental';
    case 'dossie':
      return 'Dossiê';
    case 'audios':
      return 'Áudio';
    default:
      return file_category;
  }
}
